export default {
  watch: {
    value: {
      handler(newVal, oldVal) {
        this.result = newVal;
      },
      immediate: true,
    },
  },
};
